export default "__VITE_ASSET__C$IpGaTS__"